document.addEventListener("turbolinks:load", function() {
  //this allows us to use html disabled attribute in rails
  //to prevent clicking on a disabled link from doing anything
  $('a[disabled]').click(function(e){
    e.preventDefault();
  });
});
